module.exports = __webpack_public_path__ + "h5/img/heziHong.8c4bd955.png";